import { connect } from 'react-redux';
import CacaAoTesouro from '../components/CacaAoTesouroComponent';
import { checkInfoActiveHunt } from '../actions/CacaAoTesouroAction';
import { setProfileModalState } from '../../profile/actions/ProfileActions';

const mapStateToProps = (state) => ({
    totalPrizes: state.cacaAoTesouro.totalPrizes,
    totalPrizesWon: state.cacaAoTesouro.totalPrizesWon,
    huntRegulation: state.cacaAoTesouro.huntRegulation,
    prizesInfo: state.cacaAoTesouro.prizesInfo,
    userLogged: !!state.profile.jwt,
    registrationComplete: !!state.profile.user.registrationComplete,
    breakpoint: state.breakpointReducer,
});

const mapDispatchToProps = (dispatch) => ({
    checkInfoActiveHunt: () => {
        dispatch(checkInfoActiveHunt());
    },
    setProfileModalState: (open) => {
        dispatch(setProfileModalState(open));
    },
});

const CacaAoTesouroContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CacaAoTesouro);

export default CacaAoTesouroContainer;
